import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "face-top-matter" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "right-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackIcon = _resolveComponent("BackIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcActions = _resolveComponent("NcActions")!
  const _component_UnassignedIcon = _resolveComponent("UnassignedIcon")!
  const _component_EditIcon = _resolveComponent("EditIcon")!
  const _component_MergeIcon = _resolveComponent("MergeIcon")!
  const _component_NcActionCheckbox = _resolveComponent("NcActionCheckbox")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_FaceEditModal = _resolveComponent("FaceEditModal")!
  const _component_FaceDeleteModal = _resolveComponent("FaceDeleteModal")!
  const _component_FaceMergeModal = _resolveComponent("FaceMergeModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.name)
      ? (_openBlock(), _createBlock(_component_NcActions, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_NcActionButton, {
              "aria-label": _ctx.t('memories', 'Back'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_BackIcon, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Back')) + " ", 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'rename-hover': _ctx.isReal }),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rename && _ctx.rename(...args)))
      }, _toDisplayString(_ctx.displayName), 3)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_NcActions, { inline: 0 }, {
        default: _withCtx(() => [
          (!_ctx.name && _ctx.routeIsRecognize && !_ctx.routeIsRecognizeUnassigned)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 0,
                "aria-label": _ctx.t('memories', 'Unassigned faces'),
                onClick: _ctx.openUnassigned,
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_UnassignedIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Unassigned faces')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isReal)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_NcActionButton, {
                  "aria-label": _ctx.t('memories', 'Rename person'),
                  onClick: _ctx.rename,
                  "close-after-click": ""
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_EditIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'Rename person')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "onClick"]),
                _createVNode(_component_NcActionButton, {
                  "aria-label": _ctx.t('memories', 'Merge with different person'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refs().mergeModal.open())),
                  "close-after-click": ""
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_MergeIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'Merge with different person')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"]),
                _createVNode(_component_NcActionCheckbox, {
                  "aria-label": _ctx.t('memories', 'Mark person in preview'),
                  "model-value": _ctx.config.show_face_rect,
                  onChange: _ctx.changeShowFaceRect
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'Mark person in preview')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "model-value", "onChange"]),
                _createVNode(_component_NcActionButton, {
                  "aria-label": _ctx.t('memories', 'Remove person'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refs().deleteModal.open())),
                  "close-after-click": ""
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_DeleteIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'Remove person')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_FaceEditModal, { ref: "editModal" }, null, 512),
    _createVNode(_component_FaceDeleteModal, { ref: "deleteModal" }, null, 512),
    _createVNode(_component_FaceMergeModal, { ref: "mergeModal" }, null, 512)
  ]))
}